import React from 'react'
import { } from 'reactstrap'
import {
    TwitterShareButton,
    TwitterIcon,
    VKShareButton,
    VKIcon,
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    LinkedinIcon,
} from "react-share"
import { withTranslation } from 'react-i18next'
import { } from 'components'
import { } from 'lib/lib'
import PropTypes from 'prop-types'

class NewsShareLinks extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            iconSize: 40,
        }
    }

    render() {
        // const { t } = this.props
        return (
            <div className="d-flex justify-content-around" >
                <TwitterShareButton url={window.location.href}>
                    <TwitterIcon size={this.state.iconSize} className="rounded" />
                </TwitterShareButton>
                <VKShareButton url={window.location.href}>
                    <VKIcon size={this.state.iconSize} className="rounded" />
                </VKShareButton>
                <FacebookShareButton url={window.location.href}>
                    <FacebookIcon size={this.state.iconSize} className="rounded" />
                </FacebookShareButton>
                <LinkedinShareButton url={window.location.href}>
                    <LinkedinIcon size={this.state.iconSize} className="rounded" />
                </LinkedinShareButton>
            </div>
        )
    }
}

NewsShareLinks.propTypes = {
    showModal: PropTypes.bool,
    t: PropTypes.func,
    toggle: PropTypes.func,
}

export default withTranslation()(NewsShareLinks)



// WEBPACK FOOTER //
// ./src/components/News/NewsShareLinks.jsx